import * as types from '../constants/action-types';

export function toggleModal ({ modalId, modalData }) {
  return {
    type: types.TOGGLE_MODAL,
    modalId,
    modalData
  };
}
